import { persistReducer } from 'redux-persist'
import { Action } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  GetMailsTableData: '[GetMailsTableData] Action',
  SetMailsData: '[SetMailsData] Action',
  GetMailsTranslateData: '[GetMailsTranslateData] Action',
  GetDeviceConfigTabTranslateData: '[GetDeviceConfigTabTranslateData] Action',
  GetDeviceConfigButtonTranslateData: '[GetDeviceConfigButtonTranslateData] Action',
}

const initialMailsState: IMailsState = {
  mailsColumnList: [],
  mailsColumnValues: [],
  mailsDefinitions: [],
  mailsColumnNames: [],
  mailsDataTypes: [],
  mailsDe: [],
  mailsEn: [],
}

export interface IMailsState {
  mailsColumnValues: [],
  mailsColumnList: [],
  mailsDefinitions: []
  mailsColumnNames: [],
  mailsDataTypes: [],
  mailsDe: [],
  mailsEn: [],
}

export const reducer = persistReducer(
  { storage, key: 'portal-Mails', whitelist:  [ ] },
  (state: IMailsState = initialMailsState, action: any) => {
    switch (action.type) {
      case actionTypes.GetMailsTableData: {
        const mailsColumnValues = JSON.parse(action.payload.data.mails);
        let mails: any = [];
        mailsColumnValues.forEach((element: any) => {
          element.forEach((item: any) => {
            mails.push(item);
          });
        });
        let headers = JSON.parse(action.payload.data.headers);
        let mailsDefinitions = JSON.parse(action.payload.data.definitions);
        let mailsColumnNames = action.payload.data.columnNames;
        let mailsDataTypes = action.payload.data.dataTypes;
        let mailsColumnList: any = [];
       
        headers.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          mailsColumnList.push(newElement[0]);
        });
        
        return { ...state, mailsColumnList, mailsColumnValues: mails, mailsDefinitions, mailsDataTypes , mailsColumnNames};
      }
    
      case actionTypes.SetMailsData: {
        const mailsColumnValues = action.payload.data;
        return { ...state, mailsColumnValues };
      }

      case actionTypes.GetMailsTranslateData: {
        const mailsDe = JSON.parse(action.payload.data.de);
        const mailsEn = JSON.parse(action.payload.data.en);
        return { ...state, mailsDe, mailsEn };
      }
      
      default:
        return state
    }
  }
)

export const actions = {
  getMailsTableData: (data: any) => ({ type: actionTypes.GetMailsTableData, payload: { data } }),
  getTranslateData: (data: any) => ({ type: actionTypes.GetMailsTranslateData, payload: { data } }),
  setMailsData: (data: any) => ({ type: actionTypes.SetMailsData, payload: { data } }),
  store: () => ({ type: "def" }),
}

export function* saga() {

}
